import constants from 'constants'
import { push } from 'react-router-redux'
import { fetchUsers, parseError, agent } from 'utils/api'

export const APP_NOTIFY = 'APP_NOTIFY'
export const APP_CLEAR_NOTIFICATION = 'APP_CLEAR_NOTIFICATION'
export const SIDEBARINFO_GETTING_SIDEBARINFO = 'SIDEBARINFO_GETTING_SIDEBARINFO'
export const SIDEBARINFO_RECEIVED_SIDEBARINFO = 'SIDEBARINFO_RECEIVED_SIDEBARINFO'

export const notify = (message, type = 'accept') => ({
  type: APP_NOTIFY,
  message,
  alertType: type,
})

export const clearNotification = () => ({
  type: APP_CLEAR_NOTIFICATION,
})

export const RESET_ERROR_MESSAGE = 'RESET_ERROR_MESSAGE'
export const SET_ERROR_MESSAGE = 'SET_ERROR_MESSAGE'

// Resets the currently visible error message.
export const resetErrorMessage = () => ({
  type: RESET_ERROR_MESSAGE,
})

export const setErrorMessage = error => ({
  error,
  type: SET_ERROR_MESSAGE,
})

const fetching = type => ({
  type,
})

const receive = (partnerSideBarData, type) => ({
  type,
  partnerSideBarData,
})

export function getUsers() {
  return (dispatch) => {
    fetchUsers()
      .then(({ data: users }) => {
        // (users)
      })
      .catch((rawError) => {
        const { error, errorMessage } = parseError(rawError)

        if (error === constants.ERROR.INTERNAL_SERVER) {
          dispatch(push({
            pathname: '/error',
            search: `?type=${constants.ERROR.INTERNAL_SERVER}`,
          }))
        } else { dispatch(notify(error)) }
      })
  }
}

export function GetPartnerSideBarDetails(empId) {
  return (dispatch) => {
    dispatch(fetching(SIDEBARINFO_GETTING_SIDEBARINFO))
    agent.PartnerSideBar.details(empId)
      .then((response) => {
        const sidebarInfo = response.map(partner => ({
          employee_id: partner.employee_id,
          status: `${partner.status === true ? 'Active' : 'Inactive'}`,
          username: partner.username,
          Counselling_Partner_Name: partner.Counselling_Partner_Name,
          Business_Leader_Name: partner.Business_Leader_Name,
          Market_Leader_Name: partner.Market_Leader_Name,
          Client_Industry_Leader_Name: partner.Client_Industry_Leader_Name,
          Service_Area_Leader_Name: partner.Service_Area_Leader_Name,
          Counselling_Partner_Employee_Id: partner.Counselling_Partner_Employee_Id,
          Business_Leader_Employee_Id: partner.business_leader_Employee_Id,
          Market_Leader_Employee_Id: partner.Market_Leader_Employee_Id,
          Client_Industry_Leader_Employee_Id: partner.Client_Industry_Leader_Employee_Id,
          Service_Area_Leader_Employee_Id: partner.Service_Area_Leader_Employee_Id,
        }))
        dispatch(receive(sidebarInfo, SIDEBARINFO_RECEIVED_SIDEBARINFO))
      })
      .catch((error) => {
        console.warn('Getting partner sidebar detail error')
        // console.error('GetPartnerSideBarDetails Error', error, error.stack) // eslint-disable-line no-console
        // dispatch(notify('Error fetching side bar info', 'warning'))
        // dispatch(push({ pathname: '/' }))
      })
  }
}



// WEBPACK FOOTER //
// ./src/actions/app.js